import * as React from 'react';
import { Button } from 'react-covideo-common';
import { NewModal } from './NewModal';
import { MdDelete, MdSave } from 'react-icons/md';
import { Gap } from './layout';
import { ParagraphNormal } from './typography';

type Props = {
  open?: boolean;
  disableSave?: boolean;
  infoBoxText?: string;
  title?: string;
  discardButtonText?: string;
  confirmButtonText?: string;
  text?: string;
  showDiscardIcon?: boolean;
  showSaveIcon?: boolean;
  onClickDiscardButton: () => void;
  onClickConfirmButton: () => void;
  handleModalClose: () => void;
};

export const ModalLeave = ({
  title = '',
  text = '',
  disableSave = false,
  discardButtonText = 'Keep video',
  confirmButtonText = 'Delete video',
  onClickDiscardButton,
  onClickConfirmButton,
  showDiscardIcon = true,
  showSaveIcon = true,
  handleModalClose = () => {},
}: Props) => {
  return (
    <NewModal
      headerText={title}
      closeModal={handleModalClose}
      style={{
        content: {
          maxWidth: '592px',
        },
      }}
    >
      <ParagraphNormal>{text}</ParagraphNormal>
      <Gap m='16px 0 0 0' width='100%' justifyContent='flex-end'>
        <Button
          icon={
            showDiscardIcon ? <MdDelete height={24} width={24} /> : undefined
          }
          text={discardButtonText}
          onClick={onClickDiscardButton}
          variant='destructive'
        />
        <Button
          icon={showSaveIcon ? <MdSave height={16} width={16} /> : undefined}
          text={confirmButtonText}
          onClick={onClickConfirmButton}
          variant='primary'
          disabled={disableSave}
        />
      </Gap>
    </NewModal>
  );
};
